import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AiSummary } from '../../domain/Ai/ai-summary';
import { PropertyStoreService } from './property-store.service';
import { PropertyService } from '../property.service';

@Injectable({ providedIn: 'root' })
export class AiSummaryStoreService {
   private summarySubject = new BehaviorSubject<AiSummary | null>(null);
   readonly summary$ = this.summarySubject.asObservable();

   private loadedForPropertyId: number | null = null;
   private lastErrorStatus: number | null = null;

   constructor(
      private propertyStore: PropertyStoreService,
      private propertyService: PropertyService
   ) {
      // React to property changes
      this.propertyStore.currentProperty.subscribe((property) => {
         if (!property?.id) {
            this.reset();
            return;
         }

         this.loadSummary(property.id);
      });
   }

   /**
    * Loads AI summary ONCE per property
    */
   loadSummary(propertyId: number): void {
      if (this.loadedForPropertyId === propertyId) return;

      this.loadedForPropertyId = propertyId;
      this.summarySubject.next(null); // signal loading

      this.propertyService.getAiSummary(propertyId).subscribe({
         next: (summary) => {
            this.lastErrorStatus = null;
            this.summarySubject.next(summary);
         },
         error: (err) => {
            this.lastErrorStatus = err.status;
            this.summarySubject.next(
               err.status === 404 || err.status === 403 ? new AiSummary() : null
            );
         }
      });
   }

   refresh(): void {
      if (!this.loadedForPropertyId) return;

      const propertyId = this.loadedForPropertyId;

      this.propertyService.invalidateAiSummaryCache(propertyId);

      this.loadedForPropertyId = null;
      this.loadSummary(propertyId);
   }

   getErrorStatus(): number | null {
      return this.lastErrorStatus;
   }

   private reset(): void {
      this.loadedForPropertyId = null;
      this.lastErrorStatus = null;
      this.summarySubject.next(null);
   }
}
